// Content derived from Technical Specification (ТЗ)

export const PROJECT_INFO = {
  title: "Система збору та публікації структурованих даних про голосування органів влади",
  shortTitle: "Voting Data API",

  description: "Система збирає з різних джерел (сайти рад, публічні/закриті API, PDF/CSV/XLSX, RSS) дані про голосування депутатів, порядок денний, депутатів і фракції/партії, присутність, допоміжні довідники та надає авторизований REST API для їх споживання сторонніми системами.",

  problem: "Сьогодні дані про голосування депутатів у місцевих радах та інших органах влади розпорошені по різних сайтах, форматах і платформах. Кожен орган публікує інформацію у власному форматі — HTML-таблиці, PDF-файли, структуровані дані через API. Це створює значні труднощі для журналістів, дослідників, громадських активістів та аналітиків.",

  solution: "Система створює єдиний структурований репозиторій з прозорим походженням (provenance) кожного запису та зручним програмним доступом через REST API.",

  businessValue: "Система дозволить журналістам швидко аналізувати голосування, дослідникам будувати статистичні моделі політичної поведінки, а громадським активістам — створювати інструменти громадського контролю без необхідності вручну збирати дані з десятків різних джерел."
};

export const FEATURES = [
  {
    title: "Множинні джерела даних",
    description: "Підтримка HTML сторінок, PDF/DOCX/XLSX/CSV файлів, публічних/закритих API та RSS стрічок."
  },
  {
    title: "ETL-пайплайн",
    description: "Асинхронна система обробки з чергами завдань, підтримкою ретраїв та exponential backoff."
  },
  {
    title: "Єдина модель даних",
    description: "Повна темпоральність даних, стабільна ідентифікація через UUID, повне provenance кожного запису."
  },
  {
    title: "REST API з JWT",
    description: "Авторизований доступ через JWT токени (тривалість 60 хв) з опційним refresh-токеном."
  },
  {
    title: "Багата фільтрація",
    description: "Фільтрація за органом, сесією, засіданням, датою, фракцією, депутатом та результатом голосування."
  },
  {
    title: "Прозорість походження",
    description: "Кожен запис містить метадані про джерело: URL, час завантаження, версію парсера, хеш контенту."
  }
];

export const API_ENDPOINTS = [
  { method: "GET", path: "api/v1/lakehouse/organizations", description: "Отримати перелік органів влади" },
  { method: "GET", path: "api/v1/lakehouse/seasons", description: "Отримати перелік сесій/скликань" },
  { method: "GET", path: "api/v1/lakehouse/meetings", description: "Отримати інформацію про засідання" },
  { method: "GET", path: "api/v1/lakehouse/votings", description: "Отримати дані про голосування" },
  { method: "GET", path: "api/v1/lakehouse/vote-records", description: "Отримати рядки голосів депутатів" },
  { method: "GET", path: "api/v1/lakehouse/deputies", description: "Отримати інформацію про депутатів" },
  { method: "GET", path: "api/v1/lakehouse/fractions", description: "Отримати дані про фракції" }
];

export const USER_ROLES = {
  ADMIN: "Адміністратор системи — керує обліковими записами, ролями, ключами доступу",
  OPERATOR: "Оператор імпортів — налаштовує конектори, запускає ETL-процеси",
  ANALYST: "Аналітик/Інтегратор — споживає REST API для аналітичних систем",
  AUDITOR: "Аудитор/Журналіст — перевіряє походження й цілісність даних"
};

export const API_LIMITS = {
  rateLimit: "60 запитів/хвилину на токен",
  tokenLifetime: "60 хвилин",
  paginationLimit: "≤ 200 записів на запит"
};